/* eslint-disable import/prefer-default-export */

export const HEADER_LINKS = [
  {
    text: '🎧 Аудиокниги',
    link: '/catalog/books/audio/',
  },
  {
    text: '👌 Бесплатные книги',
    link: '/catalog/books/free/',
  },
  {
    text: '🔥 Новинки',
    link: '/sets/?rubric=4',
  },
  {
    text: '❤️ Топ книг',
    link: '/sets/?rubric=150',
  },
  {
    text: '🎙 Топ аудиокниг',
    link: '/sets/?rubric=151',
  },
];
